import { type FragmentOf, graphql, readFragment, type Scalar } from "@/graphql"

const graphQLFragments = {
    agreement: graphql(`
        fragment isAgreementBeingActivated_Agreement on AgreementType {
            __typename
            status
        }
    `),
}

const AGREEMENT_BEING_ACTIVATED_STATUS = [
    "AWAITING_SWITCH_IN_DECISION",
    "INITIAL_METER_REGISTERED",
    "NEW",
    "PENDING_SITE_WORKS",
    "PRE_APPLICATION",
    "SWITCH_IN_APPLICATION_CONFIRMED",
] as const satisfies Array<Scalar<"ActivationProcessStatus">>

export function isAgreementBeingActivated(fragment: FragmentOf<typeof graphQLFragments.agreement>) {
    const agreement = readFragment(graphQLFragments.agreement, fragment)

    if (!agreement.status) {
        return false
    }

    return AGREEMENT_BEING_ACTIVATED_STATUS.includes(agreement.status)
}

isAgreementBeingActivated.fragments = graphQLFragments
